export default __webpack_public_path__ + "static/vault-payment-methods-e20caaafcb1ffbbc93a74767e23d74ed.png";